// script.js
document.addEventListener("DOMContentLoaded", function () {
	const accordionItems = document.querySelectorAll(".accordion-item")

	accordionItems.forEach(function (item) {
		const heading = item.querySelector(".accordion-heading")
		const content = item.querySelector(".accordion-content")

		heading.addEventListener("click", function () {
			content.style.display = content.style.display === "block" ? "none" : "block"
			heading.classList.toggle("active")
		})
	})

	//new functionality filter
	const verticalDrawer_facetsWrapper = document.querySelector(".drawer-vertical-filters .facets-wrapper")
	const filterButton = document.querySelector(".drawer-vertical-filters .mobile-facets__open-wrapper")
	let productList = document.querySelectorAll(".drawer-vertical-filters #product-grid li")

	verticalDrawer_facetsWrapper.style.display = "none" // Hide the element
	productList.forEach((product) => {
		product.classList.add("product-width-22")
	})
	filterButton.addEventListener("click", () => {
		//The filter causes a re-render that's why we have to search the product-list
		productList = document.querySelectorAll(".drawer-vertical-filters #product-grid li")
		if (verticalDrawer_facetsWrapper.style.display === "none" || verticalDrawer_facetsWrapper.style.display === "") {
			verticalDrawer_facetsWrapper.style.display = "block" // Show the element
			productList.forEach((product) => {
				product.classList.remove("product-width-22")
				product.classList.add("product-width-30")
			})
		} else {
			verticalDrawer_facetsWrapper.style.display = "none" // Hide the element
			productList.forEach((product) => {
				product.classList.remove("product-width-30")
				product.classList.add("product-width-22")
			})
		}
	})
	const mediaQuery = window.matchMedia("(max-width: 748px)")
	function handleMediaQueryChange(e) {
		if (e.matches) {
			verticalDrawer_facetsWrapper.style.display = "block"
		}
	}
	handleMediaQueryChange(mediaQuery)
	mediaQuery.addEventListener("change", handleMediaQueryChange)

    const mediaQueryDesktop = window.matchMedia("(min-width: 748px)");
    function handleMediaQueryChangeDesktop(e) {
      if (e.matches) {
        const isOpen = document.querySelector('.medium-hide .disclosure-has-popup[open]')
        if(isOpen){
          verticalDrawer_facetsWrapper.style.display = "block";
          productList.forEach(product => {
              product?.classList.remove("product-width-22");
              product?.classList.add("product-width-30");
          });
        } else {
          verticalDrawer_facetsWrapper.style.display = "none";
          productList.forEach(product => {
            product?.classList.remove("product-width-30");
            product?.classList.add("product-width-22");
          });
        }
          
      } 
    }
    handleMediaQueryChangeDesktop(mediaQueryDesktop)
    mediaQueryDesktop.addEventListener("change", handleMediaQueryChangeDesktop);
})

/*Obfuscated Links*/
document.querySelectorAll(".js-link").forEach(function (el) {
	el.addEventListener("click", function () {
		window.location.href = atob(el.dataset.h)
	})
})

document.querySelectorAll(".js-link-blank").forEach(function (el) {
	el.addEventListener("click", function () {
		window.open(atob(el.dataset.h), "_blank")
	})
})

// Get all elements with class "accordion-title"
const accordionTitles = document.querySelectorAll(".accordion-title")

// Iterate over each accordion title element
accordionTitles.forEach(function (accordionTitle) {
	// Add a click event listener to each accordion title
	accordionTitle.addEventListener("click", function () {
		// Get the next sibling element (accordion content)
		const accordionContent = this.nextElementSibling

		// Toggle the display of the accordion content with a slide effect (200ms duration)
		accordionContent.style.display = accordionContent.style.display === "block" ? "none" : "block"

		// Toggle the "open" class on the parent element (accordion_block) with a 200ms duration
		const accordionBlock = this.parentElement
		accordionBlock.classList.toggle("open")
	})
})

jQuery(document).ready(function ($) {
	$(".footer_top .f_nav a").click(function (e) {
		var getHash = $(this).attr("href").split("#")[1]
		if (getHash && $("#" + getHash + "").length) {
			e.preventDefault()
			$("html, body").animate(
				{
					scrollTop: $("#" + getHash + "").offset().top - 300,
				},
				2000
			)
		}
	})
	if (window.location.hash) {
		var elem = $("#" + window.location.hash.replace("#", ""))
		if (elem.le) {
			$("html, body").animate(
				{
					scrollTop: elem.offset().top - 300,
				},
				2000
			)
		}
	}

	$("#slider-range").slider({
		range: true,
		min: 0,
		max: $('input[name="filter.v.price.lte"]').attr("max"),
		values: [
			$('input[name="filter.v.price.gte"]').val(),
			$('input[name="filter.v.price.lte"]').val() == 0
				? $('input[name="filter.v.price.lte"]').attr("max")
				: $('input[name="filter.v.price.lte"]').val(),
		],
		slide: function (event, ui) {
			$(".range-value").find(".min").text(ui.values[0])
			$(".range-value").find(".min").append(" €")
			//buscar el input con el id Filter-Prc-GTE, introducir el valor de la linea de arriba
			$('input[name="filter.v.price.gte"]').val(ui.values[0])

			$(".range-value").find(".max").text(ui.values[1])
			$(".range-value").find(".max").append(" €")
			//buscar el input con el id Filter-Prc-LTE, introducir el valor de la linea de arriba
			$('input[name="filter.v.price.lte"]').val(ui.values[1])
		},
		stop: function (event, ui) {
			$("#FacetFiltersForm")[0].dispatchEvent(new Event("filterProducts"))
		},
	})
	$(".range-value").find(".min").text($("#slider-range").slider("values", 0))
	$(".range-value").find(".min").append(" €")
	$(".range-value").find(".max").text($("#slider-range").slider("values", 1))
	$(".range-value").find(".max").append(" €")
})

function initializeSlider($slider) {
	if ($slider.length) {
		var currentSlide
		var slidesCount
		var sliderCounter = document.createElement("div")
		sliderCounter.classList.add("slider__counter")

		var updateSliderCounter = function (slick, currentIndex) {
			currentSlide = slick.slickCurrentSlide() + 1
			slidesCount = slick.slideCount
			$(sliderCounter).text(currentSlide + "/" + slidesCount)
		}

		$slider.on("init", function (event, slick) {
			$slider.append(sliderCounter)
			updateSliderCounter(slick)
		})

		$slider.on("afterChange", function (event, slick, currentSlide) {
			updateSliderCounter(slick, currentSlide)
		})

		$slider.slick({
			speed: 1000,
			fade: true,
			arrows: true,
			customPaging: function (slider, i) {
				var thumb = $(slider.$slides[i]).data()
				return "0" + (i + 1)
			},
		})
	}
}

function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
	const [from, to] = getParsed(fromInput, toInput)
	fillSlider(fromInput, toInput, "#C6C6C6", "#25daa5", controlSlider)
	if (from > to) {
		fromSlider.value = to
		fromInput.value = to
	} else {
		fromSlider.value = from
	}
}

function controlToInput(toSlider, fromInput, toInput, controlSlider) {
	const [from, to] = getParsed(fromInput, toInput)
	fillSlider(fromInput, toInput, "#C6C6C6", "#25daa5", controlSlider)
	setToggleAccessible(toInput)
	if (from <= to) {
		toSlider.value = to
		toInput.value = to
	} else {
		toInput.value = from
	}
}

function controlFromSlider(fromSlider, toSlider, fromInput) {
	const [from, to] = getParsed(fromSlider, toSlider)
	fillSlider(fromSlider, toSlider, "#C6C6C6", "#25daa5", toSlider)
	if (from > to) {
		fromSlider.value = to
		fromInput.value = to
	} else {
		fromInput.value = from
	}
}

function controlToSlider(fromSlider, toSlider, toInput) {
	const [from, to] = getParsed(fromSlider, toSlider)
	fillSlider(fromSlider, toSlider, "#C6C6C6", "#25daa5", toSlider)
	setToggleAccessible(toSlider)
	if (from <= to) {
		toSlider.value = to
		toInput.value = to
	} else {
		toInput.value = from
		toSlider.value = from
	}
}

function getParsed(currentFrom, currentTo) {
	const from = parseInt(currentFrom.value, 10)
	const to = parseInt(currentTo.value, 10)
	return [from, to]
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
	const rangeDistance = to.max - to.min
	const fromPosition = from.value - to.min
	const toPosition = to.value - to.min
	controlSlider.style.background = `linear-gradient(
  to right,
  ${sliderColor} 0%,
  ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
  ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
  ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
  ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
  ${sliderColor} 100%)`
}

function setToggleAccessible(currentTarget) {
	const toSlider = document.querySelector("#toSlider")
	if (Number(currentTarget.value) <= 0) {
		toSlider.style.zIndex = 2
	} else {
		toSlider.style.zIndex = 0
	}
}

const fromSlider = document.querySelector("#fromSlider")
const toSlider = document.querySelector("#toSlider")
const fromInput = document.querySelector("#fromInput")
const toInput = document.querySelector("#toInput")
fillSlider(fromSlider, toSlider, "#C6C6C6", "#25daa5", toSlider)
setToggleAccessible(toSlider)

fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput)
toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput)
fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider)
toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider)
